<template>
  <div class="flex flex-col bg-white">
    <div
      v-if="courselist_loading"
      class="flex h-screen items-center justify-center"
    >
      <pl-spinner class="x3" />
    </div>
    <div v-else class="flex-grow">
      <admin-dashboard
        v-if="getProfile.role === 'admin'"
        class="container mx-auto h-full"
      />
      <div v-else>
        <default-layout>
          <DashboardCards />
        </default-layout>
      </div>
    </div>
    <!-- Modals/Overlays -->
    <NewPremadeModal
      v-if="show_new_premade_modal"
      @close="show_new_premade_modal = false"
      :premadeId="premade_id"
      :premadeType="premade_type"
      :openAiTitle="open_ai_title"
      :openAiPrompt="open_ai_prompt"
    />
    <FullScreenChooseActivity
      v-if="show_choose_activity_overlay"
      @close="show_choose_activity_overlay = false"
    />
    <Draft 
      v-if="isDraftOpen === true" 
      :id="selectedDraft.id"
      :type="selectedDraft.type"
      @close="isDraftOpen = false"
    />
  </div>
</template>
<script>
  /* import Axios from 'axios'; */
  import { mapGetters } from 'vuex';
  import store from 'store';
  import { EventBus } from 'utils/event-bus';
  import { get } from 'lodash';
  import Draft from '../Drafts/Index.vue';

  import accountService from 'services/account';
  import URLconfigs from 'services/apiConfigs';
  import profileServices from 'services/profile/profileServices';
  import authenticationServices from 'features/authentication/authentication.services';
  import premadeServices from 'services/premades/premadeServices';
  import adminServices from 'services/admin/adminServices';
  /* import openAiServices from 'services/openAi/openAiServices'; */

  import NewPremadeModal from 'components/modals/newPremadeModal/newPremadeModal';
  import AdminDashboard from 'features/admin/adminDashboard';
  import TheHeader from 'components/navbar/theHeader';

  import Profile from 'features/profile/profile.vue';
  /* import CourseTable from '../../Pages/Courses/Courses.vue'; */

  import slidingButton from './slidingButton';

  import FullScreenChooseActivity from 'features/courses/components/fullScreenChooseActivity';
  import onlineRoundtableSockets from 'mixins/sockets/onlineRoundtableSocketEvents';

  export default {
    data() {
      return {
        courselist_loading: false,
        show_new_premade_modal: false,
        show_choose_activity_overlay: false,
        coursesLength: 0,
        premade_type: '',
        page: null,
        recent_rts: [],
        isDraftOpen: false,
        selectedDraft: {},
      };
    },
    components: {
      DashboardCards: () => import('features/dashboard/dashboardTable.vue'),
      TheHeader,
      Draft,
      NewPremadeModal,
      AdminDashboard,
      slidingButton,
      FullScreenChooseActivity,
      Profile,
      /* CourseTable, */
      DefaultLayout: () => import('layouts/default/default.vue'),
    },
    mixins: [onlineRoundtableSockets],
    computed: {
      ...mapGetters(['getProfile', 'getCourses', 'getInstructorCourses', 'getParticipantCourses']),
      premade_id() {
        return (
          this.$route.query.premade_id || localStorage.getItem('premade_id')
        );
      },
      miniMenu() {
        return this.showSlidingRightMenu;
      },
      open_ai() {
        return this.$route.query.open_ai || localStorage.getItem('open_ai');
      },
      open_ai_type() {
        return this.$route.query.type || localStorage.getItem('type');
      },
      courses_I_teach() {
        return this.getCourses.filter((course) => {
          if (course.is_sample !== true && course.is_archived === false) {
            const role = get(course, 'users[0].subscription.role');
            return ['author', 'co-teacher'].includes(role);
          }
        });
      },
      can_create_activities() {
        return Boolean(
          this.getProfile.is_paid || this.getProfile.activity_passes
        );
      },
    },
    methods: {
      showChooseActivityOverlay() {
        accountService.completeInfo().then((res) => {
          this.$store.dispatch('setAccount', res.data);
          this.show_choose_activity_overlay = true;
        });
      },
      goToUniverse() {
        const universe_url = `${URLconfigs.universeURL}/roundtables/browse`;
        authenticationServices.navigateToExternalWithAuth(universe_url);
      },
      goToMyPortfolio() {
        if (!this.getProfile.profile_url) {
          profileServices
            .createProfile(this.getProfile.id)
            .then(({ data }) => {
              const profile_url = `${URLconfigs.universeURL}/profiles/${data.profile_url}`;
              authenticationServices.navigateToExternalWithAuth(profile_url);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const profile_url = `${URLconfigs.universeURL}/profiles/${this.getProfile.profile_url}`;
          authenticationServices.navigateToExternalWithAuth(profile_url);
        }
      },
      getRoundtables: async function () {
        await this.$store.dispatch('getRecentRoundtables');
      },
    },
    mounted: async function () {
      await this.$store.dispatch('setDashboardRole', this.getProfile.role);

      if(this.getProfile.profile_url === null) {
        profileServices.createProfile(this.getProfile.id).then(({ data }) => {
          this.profile_url = data.profile_url;
        }).catch((error) => {
          console.error(error);
        });
      }
      
      if (this.$route.query._prly_tk) {
        this.$router.replace({ query: {} });
      }
      if (this.$route.query.code) {
        const code = this.$route.query.code;
        const redirect_uri = `${URLconfigs.uiURL}/dashboard`;
        const course_id = sessionStorage.getItem('course_id');
        const activity_id = sessionStorage.getItem('activity_id');
        const activity_type = sessionStorage.getItem('activity_type');
        const payload = { code, redirect_uri, course_id };
        if (activity_id) {
          this.$store
            .dispatch('generateSubscriptionSsoTokens', payload)
            .then((res) => {
              if (activity_id) {
                let route = {};
                let integration_id = res.integration_id;
                if (activity_type === 'online' && course_id) {
                  route = {
                    name: 'student.settings',
                    params: { courseID: course_id },
                    query: {
                      roundtableID: activity_id,
                      integrationID: integration_id,
                    },
                  };
                } else if (activity_type === 'online') {
                  route = {
                    name: 'roundtable.submit',
                    params: this.$route.params,
                    query: { integrationID: integration_id },
                  };
                } else if (activity_type === 'live' && course_id) {
                  route = {
                    name: 'student.settings',
                    params: { courseID: course_id },
                    query: {
                      discussionID: activity_id,
                      integrationID: integration_id,
                    },
                  };
                }
                sessionStorage.removeItem('course_id');
                sessionStorage.removeItem('activity_id');
                sessionStorage.removeItem('activity_type');
                this.$router.push(route);
                
              }
            });
        } else {
          this.$store.dispatch('generateSsoTokens', payload).then((res) => {
            let integration_id = res.integration.id;
            if (course_id) {
              const route = {
                name: 'course.settings.integrations',
                params: { courseID: course_id },
                query: { integrationID: integration_id },
              };
              sessionStorage.removeItem('course_id');
              sessionStorage.removeItem('activity_id');
              sessionStorage.removeItem('activity_type');
              adminServices.setSsoIntegrationProfile(integration_id);
              this.$store.dispatch('updateProviders', {
                integration_id,
                connect: true,
              });
              this.$router.push(route);
            }
          });
        }
      }
      if (this.premade_id) {
        premadeServices.getPremadeById(this.premade_id).then(({ data }) => {
          this.premade_type = data.type;
          this.show_new_premade_modal = true;
        });
      }

      EventBus.$on('open-new-premade-modal', async (premadeId) => {
        if (premadeId) {
          try {
            const { data } = await premadeServices.getPremadeById(premadeId);
            this.premade_type = data.type;
            this.show_new_premade_modal = true;
          } catch (error) {
            console.log(error);
          }
        }
      });

      

      const role = this.getProfile.role;
      if (role === 'teacher' && this.getProfile.is_onboarded === false) {
        EventBus.$emit('open-welcome-modal');
      }
      if (role !== 'admin') {
        if (role === 'teacher' && this.getInstructorCourses.length === 0 && this.getParticipantCourses.length === 0) {
          this.courselist_loading = true;
          await store.dispatch('handleSetInstructorCourses', { role });
          await store.dispatch('handleSetParticipantCourses', { role: 'teacher' });
          await store.dispatch('setCourseList', role);
          this.courselist_loading = false;
        }
        if (role !== 'teacher' && this.getParticipantCourses.length === 0) {
          this.courselist_loading = true;
          await store.dispatch('handleSetParticipantCourses', { role: 'student' });
          this.courselist_loading = false;
        }
      }
      if (role !== 'admin') {
        this.getRoundtables();
      }

      EventBus.$on('duplicate_rt', () => {
        this.getRoundtables();
      });

      if (this.open_ai) {
        if (!this.can_create_activities) {
          EventBus.$emit('open-upgrade-modal');
          return;
        }
        if (role !== 'admin' && !this.getInstructorCourses.length) {
          /* await store.dispatch('setCourseList', role); */
          /* await store.dispatch('handleSetInstructorCourses', { role });
          if (!this.courses_I_teach.length) {
            const course_payload = {
              title: 'My First Course',
              sections: ['001'],
              banner_url: '/static/banners/Classical.png',
            };
            await store.dispatch('createCourse', course_payload);
          } */
        }
        console.log(this.open_ai);
        this.selectedDraft.id = this.open_ai;
        this.selectedDraft.type = this.open_ai_type;
        this.isDraftOpen = true;
        /* const { data } = await openAiServices.getOpenAiById(this.open_ai);
        if (this.courses_I_teach.length > 1) {
          this.premade_type = 'open-ai';
          this.open_ai_title = data.title;
          this.open_ai_prompt = data.content;
          this.show_new_premade_modal = true;
        } else {
          const payload = {
            course_id: this.courses_I_teach[0].id,
            title: data.title,
            prompt: data.content,
            user_created: true,
            is_generated_by: 'from_genie',
          };
          await this.$store.dispatch('createOnlineRoundtable', payload);
        } */
      }
    },
    beforeRouteLeave: async function (to, from, next) {
      if (this.getProfile.role !== 'student') {
        await this.$store.dispatch('setDashboardRole', 'teacher');
        //this.$store.dispatch('getRecentRoundtables', 'teacher');
      }
      localStorage.removeItem('open_ai');
      localStorage.removeItem('type');
      next();
    },
    beforeDestroy: async function () {
      if (this.getProfile.role !== 'student') {
        await this.$store.dispatch('setDashboardRole', 'teacher');
      }
      localStorage.removeItem('type');
    },
  };
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// dashboard.vue?28630357